import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { ArchiveItemDialog } from '@/features/inventory/admin/ArchiveItemDialog'
import { type ArchiveItemDialogViewModel } from './ArchiveItemDialogViewModel'

export interface ArchiveItemDialogContainerProps {
  vm: ArchiveItemDialogViewModel
}

export const ArchiveItemDialogContainer = observer(
  function ArchiveItemDialogContainer({ vm }: ArchiveItemDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))

    return (
      <ArchiveItemDialog
        showing={vm.modal.showing}
        onClose={vm.cancel}
        onArchive={vm.archive}
        isArchivePending={vm.archive.pending}
        isOverride={vm.inventoryItem?.override}
        inventoryItemName={vm.inventoryItem?.name}
        workspaceName={vm.inventoryItem?.workspace?.name}
        corporateMode={shellInfo.corporateMode}
        testId="inventory-items"
      />
    )
  },
)
